import { render, staticRenderFns } from "./ServiceBox.vue?vue&type=template&id=7cda3898&"
import script from "./ServiceBox.vue?vue&type=script&lang=js&"
export * from "./ServiceBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports